import Wrapper from "@/layout/Wrapper";
import HomeComponent from "@/components/home-16";

export default function Home({ initialWorkers }) {
  return (
    <Wrapper>
      <HomeComponent initialWorkers={initialWorkers} />
    </Wrapper>
  );
}
